"use client";

import { createContext, useContext, useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import {useSessionTimeout} from "@/Components/common/Logout/useSessionTimeout";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const router = useRouter();

    const [isAuthLoaded, setIsAuthLoaded] = useState(false);

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Read token AFTER hydration
  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(Boolean(token));
    setIsAuthLoaded(true); // indicates auth is ready
  }, []);

 // LOGIN
const login = (token, role) => {
  localStorage.setItem("token", token);
  localStorage.setItem("role", role);
  localStorage.setItem("lastActivityTime", Date.now().toString());

  setIsAuthenticated(true);

  if (role === "runner") {
    router.push("/runner");
  } else if (role === "manager") {
    router.push("/manager/dashboard");
  } else {
    router.push("/dashboard");
  }
};

  // LOGOUT
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("lastActivityTime");
    localStorage.removeItem("lab_name");

    setIsAuthenticated(false);

    router.push("/login");
  };

  useSessionTimeout(logout, isAuthenticated);

    if (!isAuthLoaded) return null;


  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
